import * as React from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import AdminContactRelationshipsSection from "components/admin/contacts/relationships-section"
import Contact from "models/contact"
import memo from "set-state-compare/build/memo"
import Nav from "./nav"
import {useAdminLayout} from "components/admin/layout"
import useI18n from "i18n-on-steroids/src/use-i18n.mjs"
import useModel from "@kaspernj/api-maker/build/use-model"
import {useParams} from "@kaspernj/api-maker/build/router/route"
import {View} from "react-native"

/** Admin contact relationships route. */
export default memo(shapeComponent(class RoutesAdminContactsRelationships extends ShapeComponent {
  /** @returns {void} */
  setup() {
    const {t} = useI18n({namespace: "js.routes.admin.contacts.relationships"})
    const params = useParams()
    const {contact} = useModel(Contact, {
      match: {params},
      select: {
        Contact: ["contactPointsCount", "id", "name"]
      }
    })

    this.contact = contact

    useAdminLayout()?.setState({active: "contacts", headerTitle: t(".relationships")})
  }

  /** @returns {React.ReactNode} */
  render() {
    const {contact} = this

    return (
      <View dataSet={this.rootViewDataSet ||= {route: "admin/contacts/relationships"}} testID="admin-contact-relationships-route">
        {contact &&
          <Nav
            active="relationships"
            contact={contact}
            style={this.navStyle ||= {marginBottom: 10}}
            testID="admin-contact-relationships-nav"
          />
        }
        <View style={this.tablesContainerViewStyle ||= {width: "100%"}} testID="admin-contact-relationships-content">
          {contact &&
            <AdminContactRelationshipsSection contact={contact} showDiagram={false} />
          }
        </View>
      </View>
    )
  }
}))
